export const headers = {
  'X-TENANT-ID': 'creditasbr',
  Accept: 'application/vnd.creditas.v1+json',
};
